import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

import { SharedBreadcrumbs } from '../../components/global/SharedBreadcrumbs/SharedBreadcrumbs';

// helpers
import get from 'lodash.get';
import { trackBreadcrumbClick } from './breadcrumbTracking';

function PdpRespBreadcrumbsComponent(props) {
    const breadcrumbs = get(props, 'item.breadcrumbs') || [];

    const handleBreadcrumbClick = e => {
        const { index } = e.target.dataset;
        trackBreadcrumbClick(breadcrumbs[index].key);
    };

    return (
        <SharedBreadcrumbs
            breadcrumbs={breadcrumbs}
            onClick={handleBreadcrumbClick}
            isLastItemActive
        />
    );
}

PdpRespBreadcrumbsComponent.propTypes = {
    item: PropTypes.object,
};

export const PdpRespBreadcrumbs = createFragmentContainer(PdpRespBreadcrumbsComponent, {
    item: graphql`
        fragment PdpRespBreadcrumbs_item on Item {
            breadcrumbs {
                key
                path
                displayName
            }
        }
    `,
});
